import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy]         = useState(false);
  const [err, setErr]           = useState('');

  async function submit(e) {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      await login(email.toLowerCase().trim(), password);
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      background: 'var(--warm-white)',
      padding: 40,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ marginBottom: 40 }}>
          <div style={{
            fontSize: 9, fontWeight: 200, letterSpacing: '0.28em',
            textTransform: 'uppercase', color: 'var(--earth)', marginBottom: 12,
          }}>
            Panel de administración
          </div>
          <h1 style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 36, fontWeight: 300, lineHeight: 1.05, marginBottom: 6,
          }}>
            Gimnasia<br />Consciente
          </h1>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontSize: 14, color: 'var(--ink-soft)' }}>
            por María Rosa Poggi
          </div>
          <div style={{ width: 32, height: 1, background: 'var(--earth)', marginTop: 18 }} />
        </div>

        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
          <Field label="Email">
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={inputStyle}
            />
          </Field>

          <Field label="Contraseña">
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={inputStyle}
            />
          </Field>

          {err && <div style={{ fontSize: 12, color: 'var(--danger)' }}>{err}</div>}

          <button type="submit" disabled={busy} style={{
            marginTop: 12, padding: 16, background: 'var(--ink)',
            color: 'var(--sand)', border: 'none', borderRadius: 4,
            fontSize: 11, fontWeight: 300, letterSpacing: '0.22em',
            textTransform: 'uppercase',
            opacity: busy ? 0.5 : 1,
          }}>
            {busy ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  background: 'transparent',
  border: 'none',
  borderBottom: '1px solid var(--border)',
  padding: '10px 0',
  fontFamily: "'Jost', sans-serif",
  fontSize: 15,
  fontWeight: 300,
  color: 'var(--ink)',
  outline: 'none',
  borderRadius: 0,
};

function Field({ label, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label style={{
        fontSize: 9, fontWeight: 300, letterSpacing: '0.22em',
        textTransform: 'uppercase', color: 'var(--earth)',
      }}>
        {label}
      </label>
      {children}
    </div>
  );
}
